import StarRating from "./StarRating";
import { coverFromTitle } from "../utils/images";

export default function BookCard({ book, onOpen }) {
  if (!book) return null;

  const cover = coverFromTitle(book.title);

  return (
    <div
      onClick={() => onOpen?.(book.id)}
      style={{
        cursor: "pointer",
        border: "1px solid #cbd5e1",
        borderRadius: 12,
        padding: 16,
        background: "#fff",
        display: "flex",
        flexDirection: "row",
        gap: 12,
        boxShadow: "0 6px 12px rgb(0 0 0 / 0.05)",
      }}
    >
      {/* Left: Letter-based book cover */}
      <div
        style={{
          width: 48,
          height: 64,
          borderRadius: 6,
          flexShrink: 0,
          background: cover.bg,
          color: cover.fg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 700,
          fontSize: 20,
          userSelect: "none",
        }}
        aria-label={`Cover for ${book.title}`}
      >
        {cover.letter}
      </div>

      {/* Right: Book info */}
      <div style={{ flexGrow: 1, minWidth: 0 }}>
        <div
          style={{
            fontWeight: 600,
            fontSize: 15,
            color: "#0f172a",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
          title={book.title}
        >
          {book.title}
        </div>

        {book.author && (
          <div
            style={{
              fontSize: 13,
              color: "#475569",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            title={book.author}
          >
            {book.author}
          </div>
        )}

        <div style={{ marginTop: 6, fontSize: 12, color: "#64748b" }}>
          <span
            style={{
              background: "#e2e8f0",
              padding: "2px 6px",
              borderRadius: 6,
              marginRight: 6,
              textTransform: "lowercase",
            }}
          >
            {book.status || "tbr"}
          </span>

          {Array.isArray(book.genres) &&
            book.genres.slice(0, 2).map((g) => (
              <span
                key={g}
                style={{
                  background: "#f1f5f9",
                  padding: "2px 6px",
                  borderRadius: 6,
                  marginRight: 4,
                }}
              >
                {g}
              </span>
            ))}
        </div>

        <div style={{ marginTop: 8 }}>
          <StarRating value={book.rating || 0} />
        </div>
      </div>
    </div>
  );
}
